import { render, staticRenderFns } from "./TopUpFailModal.vue?vue&type=template&id=c1efb1b6&scoped=true&"
import script from "./TopUpFailModal.vue?vue&type=script&lang=js&"
export * from "./TopUpFailModal.vue?vue&type=script&lang=js&"
import style0 from "./TopUpFailModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TopUpFailModal.vue?vue&type=style&index=1&id=c1efb1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1efb1b6",
  null
  
)

export default component.exports